import axios from 'CanExConfig/axios'

export const createUploadedFile = async (id, data) => {
  const formData = new FormData()
  formData.append('file', data)

  const response = await axios(`/api/candidate/profiles/${id}/uploaded_files`, {
    method: 'POST',
    data: formData,
  })

  return response.data.result
}

export const fetchUploadedFiles = async id => {
  const response = await axios(`/api/candidate/profiles/${id}/uploaded_files`, {
    method: 'GET',
  })

  return response.data.result
}

export const deleteUploadedFile = async id => {
  const response = await axios(`/api/candidate/uploaded_files/${id}`, {
    method: 'DELETE',
  })

  return response.data.result
}
